import { cacheDom } from "../utils/QuerySelectors.js"

const dom = {}
const qs = {
  mainSwiper: 'data-swiper',
}
const qsAll = {
  sections: 'data-section-type="slider"',
}

const initSwiper = (section) => {
  new Swiper(section.querySelector(`[${qs.mainSwiper}]`), {
    speed: 500,
    slidesPerView: 3,
    spaceBetween: 24,
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
    breakpoints: {
      320: {
        slidesPerView: 1.5,
        spaceBetween: 16,
      },
      640: {
        slidesPerView: 2.5,
        spaceBetween: 16,
      },
      768: {
        slidesPerView: 3.5,
        spaceBetween: 16,
      },
      1024: {
        slidesPerView: 3,
        spaceBetween: 16,
      },
      1280: {
        slidesPerView: 3,
        slidesPerGroup: 3,
        spaceBetween: 24,
      },
    },
    pagination: {
      el: '.swiper-pagination',
      type: 'bullets',
      clickable: true,
    },
  })
}

export const setupSlider = () => {
  cacheDom(dom, qs, qsAll)
  dom.sections.forEach(section => initSwiper(section))
}